import {
  MessageResponseDto,
  GetContractDto,
  ContractControllerGet200Response,
  ContractApiFp,
  DeleteContractDto,
  CreateContractBaseDto,
  EditContractBaseDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseContractModel = ContractControllerGet200Response;
export type GetContractModel = GetContractDto;
export type MutateResponseContractModel = MessageResponseDto;
export type CreateContractModel = CreateContractBaseDto;
export type UpdateContractModel = EditContractBaseDto;
export type DeleteContractModel = DeleteContractDto;

export interface CreateContractModelExtension {
  contract: CreateContractModel;
  file: File;
}

export interface UpdateContractModelExtension {
  contract: UpdateContractModel;
  file: File;
}

export const apiContractFp = ContractApiFp(apiConfig);
export const getContractController = apiContractFp.contractControllerGet;
export const createContractController = apiContractFp.contractControllerCreate;
export const updateContractController = apiContractFp.contractControllerEdit;
export const deleteContractController = apiContractFp.contractControllerDelete;

export const QueryKeyContract = QueryKey.Contract;
